import { render, staticRenderFns } from "./StockTrfList_Search.vue?vue&type=template&id=56ec621e&"
import script from "./StockTrfList_Search.vue?vue&type=script&lang=js&"
export * from "./StockTrfList_Search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports